const SET_ERROR = 'setError';

const state = {
    response: null,    
};

const actions = {
    [SET_ERROR]: async ({ state, commit, dispatch }, error) => {
        commit(SET_ERROR, error);
    }
};

const mutations = {
    [SET_ERROR](state, error) {
        state.response = error;        
    }    
};

export default {
    namespaced: true,
    actions,
    state,
    mutations
};


// WEBPACK FOOTER //
// ./skins/xkiosk/data/error.js